export default __webpack_public_path__ + "static/media/icon-warning-fill.d08e0388.svg";